<button mat-raised-button color="primary" (click)="handleClick()" [disabled]="loading" class="w-full p-8 text-xl font-semibold">
  <span *ngIf="!loading">{{ btnText }}</span>
  <mat-spinner *ngIf="loading" diameter="24"></mat-spinner>
</button>